<!-- 自动出价审核 -->
<template>
    <router-view v-if="$route.path !== '/autopricecheck'"></router-view>
    <div class="practical-table" v-else ref="scrollableDiv">
        <div class="container card">
            <!-- tab栏 -->
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!-- 我的审核 -->
                <el-tab-pane label="我的审核" name="secend">
                    <ultrataskView ref="mytaskViewRef" :prop="plainTaskViewProps"> </ultrataskView>
                </el-tab-pane>

                <!-- 我的出价 -->
                <el-tab-pane label="我的出价" name="mynobuy">
                    <div>
                        <h1 style="color: white">筛选条件</h1>
                        <div class="tiptop">
                            <el-tooltip class="box-item" effect="dark" content="Top Center prompts info" placement="top">
                                <template #content>
                                    下单【日期】是指【一天内】（00:00~23:59）的订单，包含【两个】不完整【批次】<br />批次号】，是指一场完整【暗拍场】（采货侠：19:00 ~ 次日
                                    8:50，回收宝：17：30 ~ 次日 8：50）的【所有】订单 <br />下单账户指【app账户】，不是系统账户<br />本页面用于系统【下单记录】查询，
                                    <b style="color: red"> <i>不包含竞拍结果</i></b>
                                </template>
                                <el-icon>
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                        </div>
                    </div>
                    <mybuyView></mybuyView>
                </el-tab-pane>

                <!-- 我的账号 -->
                <el-tab-pane label="我的账号" name="myouttercount">
                    <personalsettingView ref="personalsettingViewRef"></personalsettingView>
                </el-tab-pane>

                <!-- 额外任务 -->
                <el-tab-pane label="额外任务" name="ultratask">
                    <ultrataskView ref="ultrataskViewRef" :prop="ultraTaskViewProps"></ultrataskView>
                </el-tab-pane>
            </el-tabs>
        </div>
        <FixedButtons @scroll-to-top="_scrollToTop" />
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";

    import { scrollToTop } from "@/utils/utils";
    // import { mapGetters } from "vuex";
    import personalsettingView from "@/views/autoprice/setting/personalsettingView.vue";
    import ultrataskView from "@/views/autoprice/setting/ultrataskView.vue";
    import mybuyView from "@/views/details/mybuyView.vue";
    export default {
        components: { FixedButtons, personalsettingView, mybuyView, ultrataskView },
        data() {
            return {
                // 进度计算
                getCalculatedataURL: "/api/biddingTask/searchProgress/",

                // 每行行高
                rowHeight: [],

                // 重置筛选的类型列表
                TyperesetsearchtaskSet: new Set(["s", "b", "m", "g", "clearmenu", "initall", "initall2"]),

                // 个人出价情况
                selectnowchecknumURL: "/api/taskInfo/getTaskAuditNumber",

                nowchecknumDict: {
                    //总数量
                    numberOfTotal: 0,
                    numberOfUnAudited: 0,
                    numberOfAudited: 0,
                    numberOfSuccessTotal: 0,
                },
                indeterminate: false,

                // 是否有序排列
                orderbyfromhightolowflag: true,

                // 前端过滤的数据
                filtertaskphoneList: [],
                originaltaskphoneList: [],

                checkStatusmenu: [
                    { label: "全部", value: -1 },
                    { label: "未审核", value: 0 },
                    { label: "已审核", value: 1 },
                ],
                formdataMenu: {
                    sourcesList: [],
                    brandList: [],
                    modelList: [],
                    gradeList: [],
                },

                windowScroll: null,
                lasspasscheckrowstyleIndex: null,

                PriceHighorLowPopShow: false,
                PriceHighorLowSelect: [],

                getlistloading: false,
                loading: false,
                tempgoodsid: null,

                informationList: [],
                allzzpriceDialogShow: false,
                freshtime: 10,
                CalculatedataList: [],

                // 进度计算
                getCalculatedataURL: "/api/biddingTask/searchProgress/",

                // 定时器
                timer: null,

                // 进度条颜色
                colors: [
                    { color: "#f56c6c", percentage: 20 },
                    { color: "#e6a23c", percentage: 40 },
                    { color: "#1989fa", percentage: 60 },
                    { color: "#6f7ad3", percentage: 90 },
                    { color: "#5cb87a", percentage: 100 },
                ],
                //进度条
                percentage: 0,
                processshow: false,

                ecxaccountList: [],

                passcheck: [],

                // 前端计算的价格列表
                frontCalList: [],
                total: 1,

                // 筛选菜单栏
                menuselect: {
                    patch: null,
                    taskId: null,
                    pageNo: 1,
                    pageSize: 10,
                    sourcesList: "",
                    brandList: "",
                    modelList: "",
                    gradeList: "",
                    checkStatus: "",
                    orderByUpsetPrice: 0,
                },

                // 查询今日任务
                taskrunid: "",
                // 默认tab
                // activeName: "first",
                activeName: "secend",

                wwe: "",
            };
        },
        created() {
            this.nickName = localStorage.getItem("nickname") || "";
            this.phone = localStorage.getItem("tel") || "";
        },
        mounted() {},
        beforeUnmount() {
            // 在销毁时清除定时器
            this.stopTimer();
        },
        methods: {
            showallimages(s, b) {
                if (s == "" || s == {}) {
                    return this.extractImageUrls(b);
                } else {
                    return s.split("|").concat(this.extractImageUrls(b));
                }
            },
            loopfirstimage(s, b) {
                if (s == "" || s == {}) {
                    return this.extractImageUrls(b)[0];
                } else {
                    return s.split("|")[0];
                }
            },
            // 点击tab栏
            handleClick(tab, event) {
                if (tab.paneName == "myouttercount") {
                    this.$refs.personalsettingViewRef.getTableList();
                } else if (tab.paneName == "secend") {
                    this.$refs.mytaskViewRef.getruntaskList();
                }
            },

            // 价格计算进度
            getCalculatedata() {
                axios
                    .get(this.getCalculatedataURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            taskId: this.menuselect.taskId,
                            patch: this.menuselect.patch,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.CalculatedataList = res.data.data;
                            this.percentage = parseFloat(
                                (
                                    ((this.CalculatedataList.totalConditionCount + this.CalculatedataList.totalSystemEvaCount) / 2 / this.CalculatedataList.totalWarePriceCount) *
                                    100
                                ).toFixed(2)
                            );
                        }
                    });
            },
            // 清除定时器
            stopTimer() {
                clearInterval(this.timer);
            },

            // 设置定时器，每10秒钟触发一次getData方法
            startTimer() {
                this.timer = setInterval(() => {
                    // 周期执行任务
                    this.getCalculatedata();
                }, this.freshtime * 1000);
            },

            // 进度条相关
            processget() {
                if (this.processshow) {
                    // 隐藏
                    this.processshow = !this.processshow;
                    this.stopTimer();
                } else {
                    if (this.menuselect.taskId) {
                        // 显示
                        this.processshow = !this.processshow;
                        this.startTimer();
                    } else {
                        this.$message.error("您没有选择发布的任务名称!");
                    }
                }
            },
            // 进度条相关
            increase() {
                this.percentage += 10;
                if (this.percentage > 100) {
                    this.percentage = 100;
                }
            },
            // 进度条相关
            decrease() {
                this.percentage -= 10;
                if (this.percentage < 0) {
                    this.percentage = 0;
                }
            },

            // 页面顶部
            _scrollToTop() {
                scrollToTop(this.$refs.scrollableDiv);
            },
        },
        watch: {},
        computed: {
            ultraTaskViewProps() {
                return {
                    selecttaslPhoneURL: "/api/WarePriceReallocation/queryDataByParam",
                    formdataMenuSelectURL: "/api/WarePriceReallocation/init",
                    show4num: false,
                    usewarepriceid: true,
                    // taskphoneList: this.taskphoneList,
                    // formdataMenu: this.formdataMenu,
                };
            },
            plainTaskViewProps() {
                return {
                    selecttaslPhoneURL: "/api/taskInfo/getTaskInfoByPage",
                    formdataMenuSelectURL: "/api/taskInfo/init",
                    show4num: true,
                    usewarepriceid: false,
                    fatherscroll: this._scrollToTop,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    h2 {
        color: #fff;
    }

    /* 表格样式*/
    .el-table {
        justify-content: center;
        --el-table-text-color: #000000;
        --el-table-border: 1px solid #ebeef5;
        --el-table-header-bg-color: #6b6b6b;
        --el-table-header-text-color: white;
    }

    :deep(.damagepiccolcss) {
        padding: 0px !important;

        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent !important;
        }

        .cell {
            height: 100% !important;
            // width: 100% !important;
            padding: 0px !important;
            display: flex;
            justify-content: center;
            /* 水平居中 */
            align-items: center;

            /* 垂直居中 */
            .el-image {
                width: 100%;
                height: 100% !important;
                object-fit: cover;
                position: relative;
                z-index: 10;
            }
        }
    }

    :deep(.operatorcol) {
        padding: 0px !important;
        height: 100%;

        .cell {
            padding: 0px !important;
            // display: flex;
            justify-content: center;
            /* 水平居中 */
            align-items: center;

            .el-button {
                margin: 1px;
            }
        }
    }

    :deep(.el-table thead th) {
        color: white;
    }

    .menu {
        padding-right: 12px;
    }

    .addone {
        width: 100%;
        justify-content: center;
        display: flex;
        background-color: aliceblue;
        border-radius: 0 0 20px 20px;
    }

    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 15px;
        }
    }

    .practical-table {
        width: 100%;
        padding: 20px 40px;
        overflow: auto;
        //color: #ffffff;
    }

    .card {
        background-color: transparent;
        border: 1px solid transparent;
    }

    .form-control {
        background-color: #ded9d9;
        margin: 0;
    }

    .thead-dark {
        background-color: #585d6b;
        color: white;
    }

    :deep(.tiptop) {
        position: relative;
    }

    :deep(.tiptop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -53px;
        left: 215px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    :deep(.el-pagination) {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    :deep(.el-form-item__content) {
        width: 160px;
    }

    :deep(.el-tabs__item) {
        color: #ffffff;
    }

    A .el-radio {
        color: #ffffff;
    }

    :deep(.el-progress__text) {
        color: #fff;
    }

    :deep(th) {
        color: #d3d3d3;
    }

    .el-button + .el-button {
        margin-left: 0 !important;
    }

    label.el-checkbox {
        margin: 0;
    }

    .el-checkbox-group {
        width: 10px;
    }

    :deep(.passprice .el-input__inner) {
        color: red;
        font-size: large;
    }

    :deep(.price .el-input__inner) {
        color: #909399;
        font-size: large;
    }

    :deep(.el-table tbody tr:hover > td) {
        background-color: transparent !important;
    }

    .btn {
        height: 32px;
        width: 80px;
        border-radius: 6px;
        background-color: #007bff;
        border-color: #2e6da4;
        color: #ffffff;
        margin-right: 20px;
    }

    .btn:hover {
        background-color: #0056b3;
        border-color: #204d74;
    }

    :deep(.el-table__column-filter-trigger i) {
        font-size: 30px;
        font-weight: bold;
    }
</style>

<style lang="scss">
    .jsdlakjsdkla {
        padding: 0px !important;
    }

    .el-table__body tr.current-row > td {
        background-color: #fdc4c4d0 !important;
    }

    input[aria-hidden="true"] {
        display: none !important;
    }
</style>
